import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const BritishVirginIslands: Country = {
    identifier: "BritishVirginIslands",
    name: "British Virgin Islands",
    countryCode: "VG",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇻🇬",
    svgPath: "m 294.47175,409.7094 0.04,0.099 -0.024,-0.002 -0.16,-0.068 -0.124,-0.005 -0.051,-0.018 -0.028,-0.037 0.248,-0.004 0.099,0.035 z m -0.301,0.812 -0.073,0.021 -0.047,-0.005 -0.016,-0.042 0.05,-0.117 0.285,-0.013 -0.199,0.156 z m -0.557,0.181 -0.22,0.011 -0.065,-0.037 0.124,-0.091 0.23,-0.011 0.067,0.024 -0.136,0.104 z",
}
